<template>
    <div class="container">
        <div class="page-content mt-10">
            <h1 class="page-heading text-center text-dark">
                Leaderboard
            </h1>

            <div class="row p-0" id="leaderboard">
                <DataTable :data="leaderBoardData">
                    <thead>
                    <tr>
                        <th>User</th>
                        <th>earned</th>
                        <th>spent</th>
                        <th>cards_drawn</th>
                        <th>sold_cards</th>
                        <th>boosters_purchased</th>
                        <th>boosters_opened</th>
                        <th>xp</th>
                    </tr>
                    </thead>
                </DataTable>
            </div>
        </div>
    </div>
</template>

<script>
import DataTable from 'datatables.net-vue3';
import DataTablesCore from 'datatables.net-dt';

DataTable.use(DataTablesCore);

export default {
    name: "LeaderBoard",
    components: {DataTable},
    data() {
        return {
            leaderBoardData: []
        };
    },
    mounted() {
        this.$store.commit('updateUserData');
        this.fetchLeaderBoard();
    },
    computed: {
    },
    watch: {
    },
    methods: {
        fetchLeaderBoard() {
            axios.get('/api/leaderboard').then(response => {
                Object.values(response.data).forEach((dataset) => {
                    this.leaderBoardData.push([
                        dataset.user.username,
                        dataset.earned,
                        dataset.spent,
                        dataset.cards_drawn,
                        dataset.sold_cards,
                        dataset.boosters_purchased,
                        dataset.boosters_opened,
                        dataset.user.account.xp,
                    ])
                })
            })
        }
    },
};
</script>


<style scoped lang="scss">

</style>
